"use client";
import React from 'react';
import './FormDocumentation.css';
import PropTypes from 'prop-types';
import { Icon, Input } from 'atm-global-stylish';

const acceptImg = ".png, .jpg, .jpeg, .pdf, .doc, .docx";

const FormThings = ({ photos, setPhotos, errors, type, optional, maxSize }) => {
	return (
		<div className='flex flex-col w-full items-center justify-center gap-5'>
			{/* CAMINANDO  */}
			{type === '0' &&
				<div className='flex flex-col w-full justify-between gap-3 my-4'>
					<p className='text-base md:text-xl text-red font-semibold text-center'>
						Toda la documentacion requerida es obligatoria
					</p>
					<p className='text-center font-normal text-base mb-8'>Archivos admitidos son: .png, .jpg, .jpeg, .pdf, .doc, .docx</p>
					<div className='w-full flex-col flex md:gap-8 items-center justify-center'>
						<div className='flex flex-col md:flex-row w-full items-center justify-center mb-5 md:mb-0 md:gap-12'>
							<FileInput maxSize={maxSize} label={"DNI FRENTE *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_dni_front: file
							}))} value={photos.photo_dni_front} error={errors.photo_dni_front} required />
						</div>
						<div className='flex flex-row w-full items-center justify-center md:gap-12'>
							<FileInput maxSize={maxSize} label={"DNI DORSO *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_dni_back: file
							}))} value={photos.photo_dni_back} error={errors.photo_dni_back} required />
						</div>
					</div>
				</div>
			}
			{/* BICICLETA  */}
			{type === '1' &&
				<div className='flex flex-col w-full justify-between gap-3 my-4'>
					<p className='text-base md:text-xl text-red font-semibold text-center'>
						Toda la documentacion requerida es obligatoria
					</p>
					<p className='text-center font-normal text-base mb-8'>Archivos admitidos son: .png, .jpg, .jpeg, .pdf, .doc, .docx</p>
					<div className='w-full flex-col flex gap-8 items-center justify-center'>
						<div className='flex flex-col md:flex-row w-full items-center justify-center md:gap-12'>
							<FileInput maxSize={maxSize} label={"DNI FRENTE *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_dni_front: file
							}))} value={photos.photo_dni_front} error={errors.photo_dni_front} required className='mb-5 md:mb-0' />
							<FileInput maxSize={maxSize} label={"DNI DORSO *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_dni_back: file
							}))} value={photos.photo_dni_back} error={errors.photo_dni_back} required />

						</div>
						<div className='flex flex-col md:flex-row w-full items-center justify-center md:gap-12'>
							<FileInput maxSize={maxSize} label={"PRESUPUESTO DE REPARACION *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_invoice_for_repairments: file
							}))} value={photos.photo_invoice_for_repairments} error={errors.photo_invoice_for_repairments} required />
							<FileInput maxSize={maxSize} label={"FOTO 1 *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_additional_1: file
							}))} value={photos.photo_additional_1} error={errors.photo_additional_1} className='mb-5 md:mb-0' required />
						</div>
						<div className='flex flex-col md:flex-row w-full items-center justify-center md:gap-12'>
							<FileInput maxSize={maxSize} label={"FOTO 2 *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_additional_2: file
							}))} value={photos.photo_additional_2} error={errors.photo_additional_2} required />
							<FileInput maxSize={maxSize} label={"FOTO 3 *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_additional_3: file
							}))} value={photos.photo_additional_3} error={errors.photo_additional_3} className='mb-5 md:mb-0' required />
						</div>
						<div className='flex flex-col md:flex-row w-full items-center justify-center md:gap-12'>
							<FileInput maxSize={maxSize} label={"FOTO 4 *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_additional_4: file
							}))} value={photos.photo_additional_4} error={errors.photo_additional_4} required />
							<FileInput maxSize={maxSize} label={"FOTO 5 *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_additional_5: file
							}))} value={photos.photo_additional_5} error={errors.photo_additional_5} required />
						</div>
					</div>
				</div>
			}
			{/* CASA  */}
			{type === '4' &&
				<div className='flex flex-col w-full justify-between gap-3 my-4'>
					<p className='text-base md:text-xl text-red font-semibold text-center'>
						Toda la documentacion requerida es obligatoria
					</p>
					<p className='text-center font-normal text-base mb-8'>Archivos admitidos son: .png, .jpg, .jpeg, .pdf, .doc, .docx</p>
					<div className='w-full flex-col flex gap-8 items-center justify-center'>
						<div className='flex flex-col md:flex-row w-full items-center justify-center md:gap-12'>
							<FileInput maxSize={maxSize} label={"DNI FRENTE *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_dni_front: file
							}))} value={photos.photo_dni_front} error={errors.photo_dni_front} required className='mb-5 md:mb-0' />
							<FileInput maxSize={maxSize} label={"DNI DORSO *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_dni_back: file
							}))} value={photos.photo_dni_back} error={errors.photo_dni_back} required />
						</div>
						<div className='flex flex-col md:flex-row w-full items-center justify-center md:gap-12'>
							<FileInput maxSize={maxSize} label={"PRESUPUESTO DE REPARACION *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_invoice_for_repairments: file
							}))} value={photos.photo_invoice_for_repairments} error={errors.photo_invoice_for_repairments} required />
							<FileInput maxSize={maxSize} label={"ESCRITURA / CONTRATO DE ALQUILER *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_additional_6: file
							}))} value={photos.photo_additional_6} error={errors.photo_additional_6} required />
						</div>
					</div>
					<div className='w-full flex-col flex gap-8 items-center justify-center'>
						<div className='flex flex-col md:flex-row w-full items-center justify-center md:gap-12'>
							<FileInput maxSize={maxSize} label={"DENUNCIA DE SINIESTRO *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_sinister_complaint: file
							}))} value={photos.photo_sinister_complaint} error={errors.photo_sinister_complaint} className='mb-5 md:mb-0' required />
							<FileInput maxSize={maxSize} label={"CERTIFICADO DE COBERTURA *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_coverage_certification: file
							}))} value={photos.photo_coverage_certification} error={errors.photo_coverage_certification} required />
						</div>
						<div className='flex flex-col md:flex-row w-full items-center justify-center md:gap-12'>
							<FileInput maxSize={maxSize} label={"FOTO 1 *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_additional_1: file
							}))} value={photos.photo_additional_1} error={errors.photo_additional_1} className='mb-5 md:mb-0' required />
							<FileInput maxSize={maxSize} label={"FOTO 2 *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_additional_2: file
							}))} value={photos.photo_additional_2} error={errors.photo_additional_2} required />
						</div>
						<div className='flex flex-col md:flex-row w-full items-center justify-center md:gap-12'>
							<FileInput maxSize={maxSize} label={"FOTO 3 *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_additional_3: file
							}))} value={photos.photo_additional_3} error={errors.photo_additional_3} className='mb-5 md:mb-0' required />
							<FileInput maxSize={maxSize} label={"FOTO 4 *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_additional_5: file
							}))} value={photos.photo_additional_5} error={errors.photo_additional_5} required />
						</div>
						<div className='flex flex-col md:flex-row w-full items-center justify-center md:gap-12'>
							<FileInput maxSize={maxSize} label={"FOTO 5 *"} setFile={(file) => setPhotos(prev => ({
								...prev,
								photo_additional_4: file
							}))} value={photos.photo_additional_4} error={errors.photo_additional_4} required />
						</div>
					</div>
				</div>
			}
		</div>
	);
};

const FileInput = ({ label, setFile, value, error, required = false, className = '', maxSize }) => {
	const handleChange = (e) => {
		const file = e?.target?.files[0] ?? null;
		if (file) {
			if (['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'].includes(file.type)) {
				setFile(file);
			} else {
				alert('Formato de archivo no permitido. Solo PNG o JPEG');
			}
		} else {
			setFile(file);
		}
	}

	return (
		<div className="flex flex-row w-full">
			<Input
				type='file'
				label={label}
				handleChange={handleChange}
				accept={acceptImg}
				inputIcon={value ? <Icon.DoubleCheck size={25} color={'#7C1338'} /> : <Icon.PlusCircle size={25} color={'#7C1338'} />}
				required={required}
				className={`${className} ${error ? 'text-shiny-pink' : ''} overflow-hidden text-ellipsis text-nowrap`}
				maxSize={maxSize}
			/>
		</div>
	);
}

FormThings.propTypes = {
    setPhotos: PropTypes.func.isRequired,
    photos: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    type: PropTypes.string,
    optional: PropTypes.bool,
};

export default FormThings;